/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDetailAppMetadata } from './UserDetailAppMetadata';
import {
    UserDetailAppMetadataFromJSON,
    UserDetailAppMetadataFromJSONTyped,
    UserDetailAppMetadataToJSON,
    UserDetailAppMetadataToJSONTyped,
} from './UserDetailAppMetadata';
import type { CurrentUserDetailOrganizationSettings } from './CurrentUserDetailOrganizationSettings';
import {
    CurrentUserDetailOrganizationSettingsFromJSON,
    CurrentUserDetailOrganizationSettingsFromJSONTyped,
    CurrentUserDetailOrganizationSettingsToJSON,
    CurrentUserDetailOrganizationSettingsToJSONTyped,
} from './CurrentUserDetailOrganizationSettings';
import type { UserDetailUserType } from './UserDetailUserType';
import {
    UserDetailUserTypeFromJSON,
    UserDetailUserTypeFromJSONTyped,
    UserDetailUserTypeToJSON,
    UserDetailUserTypeToJSONTyped,
} from './UserDetailUserType';
import type { CurrentUserDetailOrganizationDetails } from './CurrentUserDetailOrganizationDetails';
import {
    CurrentUserDetailOrganizationDetailsFromJSON,
    CurrentUserDetailOrganizationDetailsFromJSONTyped,
    CurrentUserDetailOrganizationDetailsToJSON,
    CurrentUserDetailOrganizationDetailsToJSONTyped,
} from './CurrentUserDetailOrganizationDetails';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
    UserFacilityAccessToJSONTyped,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface CurrentUserDetail
 */
export interface CurrentUserDetail {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    status: CurrentUserDetailStatusEnum;
    /**
     * 
     */
    auth_method: CurrentUserDetailAuthMethodEnum;
    /**
     * 
     */
    username?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    gender?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    date_of_hire?: string;
    /**
     * 
     */
    s3_photo_key?: string;
    /**
     * 
     */
    s3_photo_url?: string;
    /**
     * 
     */
    pin?: string;
    /**
     * 
     */
    last_sign_in_time?: string;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    emergency_contact_name?: string;
    /**
     * 
     */
    emergency_contact_number?: string;
    /**
     * 
     */
    receive_crm_notifications?: boolean;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    user_type_id: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    organization_employment_type_id?: string;
    /**
     * 
     */
    login_url_preference?: string;
    /**
     * 
     */
    hospital_chat_signature?: string;
    /**
     * 
     */
    is_deleted?: boolean;
    /**
     * 
     */
    deletedAt?: string;
    /**
     * 
     */
    user_type?: UserDetailUserType;
    /**
     * 
     */
    user_facility_accesses?: Array<UserFacilityAccess>;
    /**
     * 
     */
    app_metadata?: UserDetailAppMetadata;
    /**
     * 
     */
    enabled_dynamic_permissions: Array<string>;
    /**
     * 
     */
    email_hash?: string;
    /**
     * Highest Pylon unread-message count the user has already acknowledged (via close or read). Counts above this are treated as new.
     */
    pylon_unread_baseline?: number;
    /**
     * Facility the user's Screener view defaults to on a fresh session. Mutually exclusive with default_screener_facility_type; both null means the home facility.
     */
    default_screener_facility_id?: string;
    /**
     * Care setting whose all-facilities Screener view the user defaults to on a fresh session. Mutually exclusive with default_screener_facility_id.
     */
    default_screener_facility_type?: string;
    /**
     * 
     */
    organization_settings: CurrentUserDetailOrganizationSettings;
    /**
     * 
     */
    organization_details: CurrentUserDetailOrganizationDetails;
}


/**
 * @export
 */
export const CurrentUserDetailStatusEnum = {
    Active: 'active',
    Pending: 'pending',
    Deactivated: 'deactivated',
} as const;
export type CurrentUserDetailStatusEnum = typeof CurrentUserDetailStatusEnum[keyof typeof CurrentUserDetailStatusEnum];

/**
 * @export
 */
export const CurrentUserDetailAuthMethodEnum = {
    Password: 'password',
    Sso: 'sso',
} as const;
export type CurrentUserDetailAuthMethodEnum = typeof CurrentUserDetailAuthMethodEnum[keyof typeof CurrentUserDetailAuthMethodEnum];


/**
 * Check if a given object implements the CurrentUserDetail interface.
 */
export function instanceOfCurrentUserDetail(value: object): value is CurrentUserDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('auth_method' in value) || value['auth_method'] === undefined) return false;
    if (!('user_type_id' in value) || value['user_type_id'] === undefined) return false;
    if (!('enabled_dynamic_permissions' in value) || value['enabled_dynamic_permissions'] === undefined) return false;
    if (!('organization_settings' in value) || value['organization_settings'] === undefined) return false;
    if (!('organization_details' in value) || value['organization_details'] === undefined) return false;
    return true;
}

export function CurrentUserDetailFromJSON(json: any): CurrentUserDetail {
    return CurrentUserDetailFromJSONTyped(json, false);
}

export function CurrentUserDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'status': json['status'],
        'auth_method': json['auth_method'],
        'username': json['username'] == null ? undefined : json['username'],
        'title': json['title'] == null ? undefined : json['title'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'date_of_hire': json['date_of_hire'] == null ? undefined : json['date_of_hire'],
        's3_photo_key': json['s3_photo_key'] == null ? undefined : json['s3_photo_key'],
        's3_photo_url': json['s3_photo_url'] == null ? undefined : json['s3_photo_url'],
        'pin': json['pin'] == null ? undefined : json['pin'],
        'last_sign_in_time': json['last_sign_in_time'] == null ? undefined : json['last_sign_in_time'],
        'address': json['address'] == null ? undefined : json['address'],
        'emergency_contact_name': json['emergency_contact_name'] == null ? undefined : json['emergency_contact_name'],
        'emergency_contact_number': json['emergency_contact_number'] == null ? undefined : json['emergency_contact_number'],
        'receive_crm_notifications': json['receive_crm_notifications'] == null ? undefined : json['receive_crm_notifications'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'user_type_id': json['user_type_id'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'organization_employment_type_id': json['organization_employment_type_id'] == null ? undefined : json['organization_employment_type_id'],
        'login_url_preference': json['login_url_preference'] == null ? undefined : json['login_url_preference'],
        'hospital_chat_signature': json['hospital_chat_signature'] == null ? undefined : json['hospital_chat_signature'],
        'is_deleted': json['is_deleted'] == null ? undefined : json['is_deleted'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
        'user_type': json['user_type'] == null ? undefined : UserDetailUserTypeFromJSON(json['user_type']),
        'user_facility_accesses': json['user_facility_accesses'] == null ? undefined : ((json['user_facility_accesses'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'app_metadata': json['app_metadata'] == null ? undefined : UserDetailAppMetadataFromJSON(json['app_metadata']),
        'enabled_dynamic_permissions': json['enabled_dynamic_permissions'],
        'email_hash': json['email_hash'] == null ? undefined : json['email_hash'],
        'pylon_unread_baseline': json['pylon_unread_baseline'] == null ? undefined : json['pylon_unread_baseline'],
        'default_screener_facility_id': json['default_screener_facility_id'] == null ? undefined : json['default_screener_facility_id'],
        'default_screener_facility_type': json['default_screener_facility_type'] == null ? undefined : json['default_screener_facility_type'],
        'organization_settings': CurrentUserDetailOrganizationSettingsFromJSON(json['organization_settings']),
        'organization_details': CurrentUserDetailOrganizationDetailsFromJSON(json['organization_details']),
    };
}

export function CurrentUserDetailToJSON(json: any): CurrentUserDetail {
    return CurrentUserDetailToJSONTyped(json, false);
}

export function CurrentUserDetailToJSONTyped(value?: CurrentUserDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'status': value['status'],
        'auth_method': value['auth_method'],
        'username': value['username'],
        'title': value['title'],
        'gender': value['gender'],
        'phone': value['phone'],
        'dob': value['dob'],
        'ssn': value['ssn'],
        'date_of_hire': value['date_of_hire'],
        's3_photo_key': value['s3_photo_key'],
        's3_photo_url': value['s3_photo_url'],
        'pin': value['pin'],
        'last_sign_in_time': value['last_sign_in_time'],
        'address': value['address'],
        'emergency_contact_name': value['emergency_contact_name'],
        'emergency_contact_number': value['emergency_contact_number'],
        'receive_crm_notifications': value['receive_crm_notifications'],
        'facility_id': value['facility_id'],
        'user_type_id': value['user_type_id'],
        'state_id': value['state_id'],
        'organization_employment_type_id': value['organization_employment_type_id'],
        'login_url_preference': value['login_url_preference'],
        'hospital_chat_signature': value['hospital_chat_signature'],
        'is_deleted': value['is_deleted'],
        'deletedAt': value['deletedAt'],
        'user_type': UserDetailUserTypeToJSON(value['user_type']),
        'user_facility_accesses': value['user_facility_accesses'] == null ? undefined : ((value['user_facility_accesses'] as Array<any>).map(UserFacilityAccessToJSON)),
        'app_metadata': UserDetailAppMetadataToJSON(value['app_metadata']),
        'enabled_dynamic_permissions': value['enabled_dynamic_permissions'],
        'email_hash': value['email_hash'],
        'pylon_unread_baseline': value['pylon_unread_baseline'],
        'default_screener_facility_id': value['default_screener_facility_id'],
        'default_screener_facility_type': value['default_screener_facility_type'],
        'organization_settings': CurrentUserDetailOrganizationSettingsToJSON(value['organization_settings']),
        'organization_details': CurrentUserDetailOrganizationDetailsToJSON(value['organization_details']),
    };
}

